import React from 'react';
import { AboutContainer, Section } from './About.Styles';

const About: React.FC = () => {
  return (
    <AboutContainer>
      <Section>
        <h1>About Sheffield Ice Tigers</h1>
        <br />
        <p>
        Formed in 2005, the Sheffield Ice Tigers are a recreational ice hockey team located in Sheffield, England, competing in the Ice Hockey Summer Classic Cups, Currently in the Intermediate and Development Cups.
        </p>
        <br />
        <p>
        The club currently has around 64 registered players and we are open to male and female players from the age of 18
        </p>
        <br />
        <p>
        We have two teams which are  our A team which is our league team & B Team which is our development team
        </p>
      </Section>
      {/* <Section>
        <h2>Our Sponsors</h2>
        <p>
        The Sheffield Ice Tigers are grateful for the support of our sponsors.
        </p>
        <img src="/images/sponsors/gri.png" alt="GRI Group" />
      </Section> */}
    </AboutContainer>
  );
};

export default About; 